import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'

import { SendOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import {
  Badge,
  Button,
  Col,
  Comment,
  Dropdown,
  Layout,
  Mentions,
  Menu,
  Row,
  Select,
  Tooltip,
} from 'antd'
import { Content, Footer } from 'antd/lib/layout/layout'
import ILeitura from 'Models/chat/ILeitura'
import IMensagem from 'Models/chat/IMensagem'
import { IDoca, IHorario } from 'Models/docas'
import moment from 'moment'
import slugify from 'react-slugify'
import WS_CHAT from 'Services/WS_CHAT'

import IUsuario from '../../../Models/docas/Usuario'
import { DocasContext } from '../Context/context'

interface IProps {
  horario: IHorario
  usuariosSelected: string[] | undefined
  setUsuariosSelected: Dispatch<SetStateAction<string[] | undefined>>
}
const ChatDetalhes = ({
  horario,
  usuariosSelected,
  setUsuariosSelected,
}: IProps): ReactElement => {
  const { docasContext } = useContext(DocasContext)
  const [mensagem, setMensagem] = useState<string>('')
  const [mensagens, setMensagens] = useState<IMensagem[]>()
  const [usuarios, setUsuarios] = useState<IUsuario[]>()

  let timerChat: any
  const messagesEndRef = useRef<HTMLHeadingElement>(null)
  const { Option } = Select

  const userDeselectDropDown = (props: any) => {
    const usersAux = usuariosSelected?.filter((x) => x !== props.key)
    setUsuariosSelected(usersAux)
  }

  const menu = useCallback(
    () => (
      <Menu
        mode="vertical"
        selectable
        multiple
        onSelect={userSelect}
        onDeselect={userDeselectDropDown}
        defaultSelectedKeys={usuariosSelected}
      >
        {usuarios?.map((user, i) => (
          <Menu.Item key={user.cdUsuario}>{user.nome}</Menu.Item>
        ))}
      </Menu>
    ),
    [usuariosSelected, usuarios, usuariosSelected?.length],
  )

  const menuLeitura = useCallback(
    (leituras: ILeitura[]) => (
      <Menu mode="vertical">
        <Menu.ItemGroup title="Não Recebidos">
          {leituras
            ?.filter((x) => !x.dtRecebido && !x.dtLeitura)
            .map((leitura, i) => (
              <Menu.Item key="setting:1">{leitura.nome}</Menu.Item>
            ))}
        </Menu.ItemGroup>
        <Menu.ItemGroup title="Recebidos">
          {leituras
            ?.filter((x) => x.dtRecebido && !x.dtLeitura)
            .map((leitura, i) => (
              <Menu.Item key="setting:1">
                <Tooltip title={leitura.dtRecebido}>{leitura.nome}</Tooltip>
              </Menu.Item>
            ))}
        </Menu.ItemGroup>
        <Menu.ItemGroup title="Lidos">
          {leituras
            ?.filter((x) => x.dtLeitura)
            .map((leitura, i) => (
              <Menu.Item key="setting:1">
                <Tooltip title={leitura.dtLeitura}>{leitura.nome}</Tooltip>
              </Menu.Item>
            ))}
        </Menu.ItemGroup>
      </Menu>
    ),
    [],
  )

  const handleChangeMensagem = (text: string) => {
    setMensagem(text.replace('\n', ''))
  }

  const getMensagens = async () => {
    const { data } = await WS_CHAT.mensagens.getMensagemByHorario(
      horario.cdAgendamentoDocasHorario,
    )
    if (data.items && data.items.length) {
      setMensagens(data.items)
    }

    if (data.usuarios && data.usuarios.length) {
      setUsuarios(data.usuarios)
    }
  }

  useEffect(() => {
    setInterval(() => {
      getMensagens()
    }, 3000)
  }, [])

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const enviaMensagem = async () => {
    const result = await WS_CHAT.mensagens.postMensagem(
      horario.cdAgendamentoDocasHorario,
      mensagem,
      horario.placa,
      horario.nomeEntidade,
      horario.cdEntidade,
      horario.cdVeiculo,
      usuariosSelected,
      docasContext.armazemAtual?.cdAgendamentoDocasArmazem,
      docasContext.armazemAtual?.cdAgendamentoDocasArmazemConfig,
      horario.cdAgendamendoDocasDocas,
    )
    const mensagensAux = mensagens
    mensagensAux?.push({
      nomeOrigem: '...enviando',
      comentario: mensagem,
    })
    getMensagens()
    setMensagens(mensagensAux)
    setUsuariosSelected([])
    setMensagem('')
    scrollToBottom()
  }

  const userSelect = (props: any) => {
    const usersAux = usuariosSelected || []
    usersAux.push(props.key)
    setUsuariosSelected(usersAux)
  }

  return (
    <Layout style={{ height: '100%' }}>
      <Content
        style={{
          height: '440px',
          overflowY: 'scroll',
          background: 'white',
        }}
      >
        {mensagens?.map((mensagem, index) => {
          return (
            <Row style={{ marginTop: '15px' }} key={index}>
              {/* <Col md={20} style={{ padding: 0}}> */}
              <Col md={20} offset={4} style={{ padding: 0 }}>
                <Row
                  align="bottom"
                  style={{
                    width: '100%',
                    backgroundColor: 'rgb(212, 222, 230)',
                  }}
                >
                  <Col flex="auto">
                    <Comment
                      style={{ padding: '0 10px' }}
                      // style={{  padding: '0 10px', background: '#eeeeee'}}
                      author={
                        <a style={{ color: '#000' }}>{mensagem.nomeOrigem}</a>
                      }
                      content={
                        <p style={{ color: '#000' }}>{mensagem.comentario}</p>
                      }
                      datetime={
                        <Tooltip
                          title={moment(mensagem.dtCadastro).format(
                            'DD/MM/YYYY HH:mm:ss',
                          )}
                        >
                          <span>{moment(mensagem.dtCadastro).fromNow()}</span>
                        </Tooltip>
                      }
                    />
                  </Col>
                  <Col flex="30px">
                    {/* <Dropdown
                            overlay={menuLeitura(mensagem.leituras!)}
                            placement="topCenter"
                            arrow
                          >
                            {mensagem?.leituras?.length ? (
                              <>
                                {mensagem.leituras?.filter((x) => !x.dtLeitura)
                                  .length ? (
                                  <>
                                    <Button
                                      style={{
                                        padding: 0,
                                        margin: 0,
                                        background: 'transparent',
                                      }}
                                    >
                                      <CheckOutlined
                                        style={{ color: '#4d4f50' }}
                                      />
                                      <CheckOutlined
                                        style={{ color: '#4d4f50' }}
                                      />
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      style={{
                                        padding: 0,
                                        margin: 0,
                                        background: 'transparent',
                                      }}
                                    >
                                      <CheckOutlined
                                        style={{ color: '#19b8e9' }}
                                      />
                                      <CheckOutlined
                                        style={{ color: '#19b8e9' }}
                                      />
                                    </Button>
                                  </>
                                )}
                              </>
                            ) : (
                              <Button
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  background: 'transparent',
                                }}
                              >
                                <CheckOutlined style={{ color: '#4d4f50' }} />
                              </Button>
                            )}
                          </Dropdown> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          )
        })}
        <div ref={messagesEndRef} />
      </Content>
      <Footer style={{ height: '33px', padding: 0 }}>
        <Row>
          <Col flex="auto">
            <Mentions
              rows={1}
              style={{ width: '100%' }}
              onChange={handleChangeMensagem}
              onSelect={userSelect}
              value={mensagem}
              placeholder="Digite sua mensagem, você também pode marcar destinatários (exemplo: @joao_silva)"
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  enviaMensagem()
                }
              }}
            >
              {usuarios?.map((user) => (
                <Option key={user.cdUsuario} value={slugify(user.nome)}>
                  {user.nome}
                </Option>
              ))}
            </Mentions>
          </Col>
          <Col flex="40px">
            <Dropdown overlay={menu} placement="topCenter" arrow>
              <Button>
                <Badge count={usuariosSelected?.length || 0}>
                  <UsergroupAddOutlined />
                </Badge>
              </Button>
            </Dropdown>
          </Col>
          <Col flex="40px">
            <Button onClick={() => enviaMensagem()}>
              <SendOutlined />
            </Button>
          </Col>
        </Row>
      </Footer>
    </Layout>
  )
}

export default ChatDetalhes
